/**
 * Exposure = „dieser Besucher hat diese Variante gesehen", Nenner der
 * Auswertung im experimentEvaluator. Einmal pro (key, visitorId) und
 * Seitenaufruf, per public IAM.
 *
 * Geschrieben wird nur auf production. Die LP spricht auf allen Stages das
 * Production-Backend an (src/aws-exports.js), Testklicks auf develop oder
 * staging landeten sonst in der Production-Auswertung, ohne dass ihre Leads
 * (Funnel auf develop/staging) dort je ankommen. Auf den anderen Stages steht
 * die Exposure nur in der Konsole.
 *
 * Fehler werden still geloggt. Eine verlorene Exposure kostet ein Datum, nie
 * die Seite.
 */
import { API } from 'aws-amplify'

import { createExperimentExposure } from '../graphql/mutations'
import { isBrowser } from '../utils'
import { STAGE } from './flags-store'
import { buildExposureInput, refFromSearch } from './helpers.js'
import { hasPerformanceConsent } from './visitor-id'

const WRITE_STAGES = ['production']

// UTM und gclid stehen an der Einstiegs-URL. Nach einer Gatsby-Navigation
// sind sie aus location.search verschwunden, deshalb beim Laden merken.
const landingSearch = isBrowser ? window.location.search : ''

const seen = new Set()
let reportedFailure = false

export const trackExposure = ({ key, variant, visitorId }) => {
  if (!isBrowser || !key || !variant || !visitorId) return

  const dedupeKey = `${key}:${visitorId}`
  if (seen.has(dedupeKey)) return
  seen.add(dedupeKey)

  const input = buildExposureInput({
    key,
    variant,
    visitorId,
    consent: hasPerformanceConsent(),
    ref: refFromSearch(landingSearch)
  })

  if (!WRITE_STAGES.includes(STAGE)) {
    console.warn(
      `[experiments] Exposure nicht geschrieben (Stage ${STAGE}):`,
      input
    )
    return
  }

  Promise.resolve()
    .then(() =>
      API.graphql({
        query: createExperimentExposure,
        variables: { input },
        authMode: 'AWS_IAM'
      })
    )
    .catch((err) => {
      if (reportedFailure) return
      reportedFailure = true
      console.warn(
        '[experiments] createExperimentExposure fehlgeschlagen:',
        err?.errors?.[0]?.message || err?.message || String(err)
      )
    })
}
